
export const headerOffset = {
    computed: {
        headerHeight() {
            const header = document?.querySelector('.scroll-offset-header');
            // variable is necessary here because if you return it directly, the script doesn't work
            const headerHeight = header?.offsetHeight ? header.offsetHeight + 'px' : 0;

            return headerHeight;
        },
    }
};
